exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* select {\n  min-width: 275px;\n} */\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/shared/agency-selection/agency-selection.component.css
// module id = ../../../../../src/app/shared/agency-selection/agency-selection.component.css
// module chunks = main